export default __webpack_public_path__ + "static/media/language-arts.9da33252.png";